/**
 * Native Base Footer will set custom theme and fix iphone 12 style issue, we need override on every Footer
 */
import React, { Component } from "react";
import { Platform } from "react-native";
import { Footer } from "native-base";
import { IPhoneXHelper } from "../../theme";

const isIos = Platform.OS === "ios";
const additionProp = isIos ? { iosBarStyle: "dark-content" } : {};

class WrappedFooter extends Component {
    render() {
        const extraStyle = this.getExtraStyle(this.props);

        return (
            <Footer {...additionProp} {...this.props} style={[this.props.style, extraStyle]}>
                {this.props.children}
            </Footer>
        );
    }

    
    getExtraStyle = props => {
        const needFitHeight = IPhoneXHelper.isIphone12PRO || IPhoneXHelper.isIphone12MAX;
        return needFitHeight ? { paddingBottom: 25 } : {};
    };
}

WrappedFooter.propTypes = {
    ...Footer.propTypes,
};
WrappedFooter.defaultValue = {
    ...Footer.defaultValue,
};
export default WrappedFooter;
